import { useEffect } from "react";
import { useAppDispatch } from "@grassrootly/rn-core";
import useBaseRequest from "../../../../api/BaseRequest";
import { GetGroupMembers } from "@grassrootly/api/providers/supabase-provider/actions";
import { groupMembersActions } from "../../../../api/groups/GroupMembersReducer";
import { GroupTabItemProps } from "../GroupTabs.types";

export function useGroupMembers({ group }: GroupTabItemProps) {
  const dispatch = useAppDispatch();
  const groupId = group.id;

  const {
    loading,
    data: groupMembers,
    execute,
  } = useBaseRequest(GetGroupMembers, {
    onCompleted: (data) => {
      if (!data) return;
      dispatch(groupMembersActions.setGroupMembers(data));
    },
  });

  useEffect(() => {
    if (groupId) {
      execute(groupId);
    }
  }, [groupId]);

  return {
    loading,
    groupMembers,
    refetch: () => {
      if (groupId) {
        execute(groupId);
      }
    },
  };
}
